module.exports = __webpack_public_path__ + "img/print.a9a7e65b.png";